/**
 * Video Slider Component
 * Instagram Reels-like video slider with play/pause functionality
 * Uses theme-scroll for cross-browser compatible scrolling (including Safari)
 */

document.addEventListener('DOMContentLoaded', function() {
  const videoSliders = document.querySelectorAll('.video-slider__carousel');
  
  if (videoSliders.length === 0) return;
  
  videoSliders.forEach(initVideoSlider);
});

function initVideoSlider(sliderElement) {
  const slides = sliderElement.querySelectorAll('.video-slider__slide');
  
  if (slides.length === 0) return;
  
  // Initialize video functionality for each slide
  slides.forEach(slide => {
    initVideoSlide(slide);
  });
}

function initVideoSlide(slide) {
  const container = slide.querySelector('.video-slider__video-container');
  const coverElement = slide.querySelector('.video-slider__cover');
  const videoWrapper = slide.querySelector('.video-slider__video');
  const video = slide.querySelector('video');
  const iframe = slide.querySelector('iframe');
  
  if (!container) return;
  
  // Hover-to-play functionality
  let hoverTimer = null;
  let isHovered = false;

  const handleMouseEnter = () => {
    isHovered = true;
    clearTimeout(hoverTimer);
    
    hoverTimer = setTimeout(() => {
      if (isHovered && container.dataset.hoverPlay === 'true') {
        startHoverVideo();
      }
    }, 1000);
  };

  const handleMouseLeave = () => {
    isHovered = false;
    clearTimeout(hoverTimer);
    stopHoverVideo();
  };

  const startHoverVideo = () => {
    pauseAllVideos();
    
    if (coverElement) {
      coverElement.style.display = 'none';
      videoWrapper.style.display = 'block';
      videoWrapper.classList.add('is-playing');
    }
    
    if (video) {
      playVideo(video);
    } else if (iframe) {
      playIframeVideo(iframe);
    }
  };

  const stopHoverVideo = () => {
    if (video) {
      pauseVideo(video);
    }
    
    if (coverElement) {
      coverElement.style.display = 'flex';
      videoWrapper.style.display = 'none';
      videoWrapper.classList.remove('is-playing');
    }
  };

  // Handle click to open popup
  const handleVideoClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    clearTimeout(hoverTimer);
    isHovered = false;
    stopHoverVideo();
    
    openVideoPopup(container);
  };

  // Add event listeners
  container.addEventListener('mouseenter', handleMouseEnter);
  container.addEventListener('mouseleave', handleMouseLeave);
  container.addEventListener('click', handleVideoClick);

  // Handle video events
  if (video) {
    video.addEventListener('ended', () => {
      if (coverElement) {
        coverElement.style.display = 'flex';
        videoWrapper.style.display = 'none';
        videoWrapper.classList.remove('is-playing');
      }
    });

    video.addEventListener('loadstart', () => {
      container.classList.add('is-loading');
    });

    video.addEventListener('canplay', () => {
      container.classList.remove('is-loading');
    });
  }

  // Handle iframe lazy loading
  if (iframe && iframe.dataset.src) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          iframe.src = iframe.dataset.src;
          observer.unobserve(iframe);
        }
      });
    });
    observer.observe(iframe);
  }
}

function playVideo(video) {
  if (video && video.paused) {
    pauseAllVideos();
    video.play().catch(error => {
      console.log('Video play failed:', error);
    });
  }
}

function pauseVideo(video) {
  if (video && !video.paused) {
    video.pause();
  }
}

function pauseAllVideos(excludeSlider = null) {
  const allSliders = document.querySelectorAll('.video-slider__carousel');
  
  allSliders.forEach(slider => {
    if (excludeSlider && slider === excludeSlider) return;
    
    const videos = slider.querySelectorAll('video');
    videos.forEach(pauseVideo);
    
    const playingVideos = slider.querySelectorAll('.video-slider__video.is-playing');
    playingVideos.forEach(videoWrapper => {
      const slide = videoWrapper.closest('.video-slider__slide');
      const cover = slide.querySelector('.video-slider__cover');
      
      if (cover) {
        cover.style.display = 'flex';
        videoWrapper.style.display = 'none';
        videoWrapper.classList.remove('is-playing');
      }
    });
  });
}

function playIframeVideo(iframe) {
  if (iframe.src.includes('youtube.com')) {
    let src = iframe.src;
    if (!src.includes('autoplay=1')) {
      src = src.replace('autoplay=0', 'autoplay=1');
    }
    iframe.src = src;
  } else if (iframe.src.includes('vimeo.com')) {
    let src = iframe.src;
    if (!src.includes('autoplay=1')) {
      src = src.replace('autoplay=0', 'autoplay=1');
    }
    iframe.src = src;
  }
}

// Pause videos when page becomes hidden
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    pauseAllVideos();
  }
});

// Handle intersection observer for performance
if ('IntersectionObserver' in window) {
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target.querySelector('video');
      
      if (!entry.isIntersecting && video && !video.paused) {
        pauseVideo(video);
        
        const slide = entry.target;
        const cover = slide.querySelector('.video-slider__cover');
        const videoWrapper = slide.querySelector('.video-slider__video');
        
        if (cover && videoWrapper) {
          cover.style.display = 'flex';
          videoWrapper.style.display = 'none';
          videoWrapper.classList.remove('is-playing');
        }
      }
    });
  }, {
    threshold: 0.5
  });

  document.addEventListener('DOMContentLoaded', () => {
    const videoSlides = document.querySelectorAll('.video-slider__slide');
    videoSlides.forEach(slide => videoObserver.observe(slide));
  });
}

// Keyboard accessibility
document.addEventListener('keydown', (e) => {
  if (e.target.matches('.video-slider__play-btn')) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.target.click();
    }
  }
});

// Video Popup Functionality
function openVideoPopup(container) {
  const modal = document.getElementById('video-popup-modal');
  const videoContent = document.getElementById('popup-video-content');
  const button = document.getElementById('popup-button');
  const buttonText = document.getElementById('popup-button-text');
  const usernameElement = document.getElementById('popup-username');
  const usernameText = document.getElementById('popup-username-text');
  
  if (!modal || !container) return;
  
  const videoType = container.dataset.videoType;
  const videoId = container.dataset.videoId;
  const buttonUrl = container.dataset.buttonUrl;
  const buttonTextContent = container.dataset.buttonText;
  const username = container.dataset.username;
  const profileUrl = container.dataset.profileUrl;
  
  videoContent.innerHTML = '';
  
  let videoElement = '';
  
  if (videoType === 'hosted') {
    const originalVideo = container.querySelector('video');
    if (originalVideo) {
      videoElement = originalVideo.cloneNode(true);
      videoElement.muted = false;
      videoElement.controls = true;
      videoElement.autoplay = true;
      videoContent.appendChild(videoElement);
    }
  } else if (videoType === 'youtube') {
    videoElement = document.createElement('iframe');
    videoElement.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&mute=0&loop=1&playlist=${videoId}`;
    videoElement.frameBorder = '0';
    videoElement.allowFullscreen = true;
    videoElement.allow = 'autoplay; encrypted-media';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoContent.appendChild(videoElement);
  } else if (videoType === 'vimeo') {
    videoElement = document.createElement('iframe');
    videoElement.src = `https://player.vimeo.com/video/${videoId}?autoplay=1&controls=1&muted=0&loop=1`;
    videoElement.frameBorder = '0';
    videoElement.allowFullscreen = true;
    videoElement.allow = 'autoplay; encrypted-media';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoContent.appendChild(videoElement);
  }
  
  if (username && usernameText) {
    usernameText.textContent = username;
  }
  
  if (profileUrl && usernameElement) {
    usernameElement.href = profileUrl;
    usernameElement.style.display = 'flex';
  } else if (usernameElement) {
    usernameElement.href = '#';
    usernameElement.style.display = username ? 'flex' : 'none';
    if (!profileUrl) {
      usernameElement.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }
  }
  
  if (buttonUrl && buttonTextContent) {
    button.href = buttonUrl;
    buttonText.textContent = buttonTextContent;
    button.style.display = 'inline-flex';
  } else {
    button.style.display = 'none';
  }
  
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  
  const closeButton = modal.querySelector('.video-popup-close');
  if (closeButton) {
    closeButton.focus();
  }
  
  document.body.style.overflow = 'hidden';
}

function closeVideoPopup() {
  const modal = document.getElementById('video-popup-modal');
  const videoContent = document.getElementById('popup-video-content');
  
  if (!modal) return;
  
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  
  if (videoContent) {
    videoContent.innerHTML = '';
  }
  
  document.body.style.overflow = '';
}

// Initialize popup event listeners
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('video-popup-modal');
  
  if (modal) {
    const closeElements = modal.querySelectorAll('[data-close-popup]');
    closeElements.forEach(element => {
      element.addEventListener('click', closeVideoPopup);
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeVideoPopup();
      }
    });
    
    const modalContent = modal.querySelector('.video-popup-content');
    if (modalContent) {
      modalContent.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }
});

// Export for potential external use
window.VideoSlider = {
  init: initVideoSlider,
  playVideo: playVideo,
  pauseVideo: pauseVideo,
  pauseAllVideos: pauseAllVideos,
  openVideoPopup: openVideoPopup,
  closeVideoPopup: closeVideoPopup
};
